import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Button, Form, ButtonGroup } from "react-bootstrap";
import AlertComponent from "../alerts/AlertComponent";
import SectionsTable from "./SectionsTable";
import SectionModel from "./SectionModal";
import { getCategories, getSections, getTags } from "../../utils/api";
import CategoryButtons from "../elements/CategoryButtons";
import { ColoredLine } from "../elements/ColoredLine";
import { checkUserToken } from "../../utils/checkUser";
import makeAnimated from 'react-select/animated';
import { useHorizontalScroll } from "../elements/useSideScroll";

//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareSquare, faPlusSquare, faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faShareSquare, faAngleRight, faPlusSquare, faAngleLeft)

const animatedComponents = makeAnimated();

const Sections = ({chosenDepartment, departmentPermission}) => {
  const scrollRef = useHorizontalScroll();
  const [openNewModal, setOpenNewModal] = useState(false);
  const [sectionCreated, setSectionCreated] = useState(false);
  const [sectionUpdated, setSectionUpdated] = useState(false);
  const [sectionError, setSectionError] = useState(false);
  const [categories, setCategories] = useState([])
  const [tags, setTags] = useState([]);

  const [sections, setSections] = useState([]);
  const [sectionsVisible, setSectionsVisible] = useState([]);
  const [sectionID, setSectionID] = useState("All")

  const [searchText, setSearchText] = useState("");
  const [chosenCategory, setChosenCategory] = useState("All");

  const [scrollX, setscrollX] = useState(0); // For detecting start scroll postion
  const [scrolEnd, setscrolEnd] = useState(false); // For detecting end of scrolling

  useEffect(() => {
    checkUserToken();
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, []);

  //Check if we need to display the right scroll button
  useEffect(() => {
    scrollCheck();
  }, [scrollRef?.current?.scrollWidth, scrollRef?.current?.offsetWidth])

  useEffect (() => {
    if (chosenDepartment !== "" && chosenDepartment !== undefined) {
      getSections(setSections, chosenDepartment, chosenCategory);
      getCategories(setCategories, chosenDepartment);
      getTags(setTags, chosenDepartment);
      setChosenCategory("All")
    }
  }, [chosenDepartment])

  useEffect(() => {
    if (chosenDepartment !== "" && chosenDepartment !== undefined) {
      getSections(setSections, chosenDepartment, chosenCategory);
    } 
  }, [chosenCategory])


  //Search function
  useEffect(() => {
    setSectionsVisible(
      sections.filter((section) => {
        const tags = section.tags.toString();
        return (
          section.name.toLowerCase().includes(searchText.toLowerCase()) ||
          section.description.toLowerCase().includes(searchText.toLowerCase()) ||
          tags.toLowerCase().includes(searchText.toLowerCase()) ||
          section._id.toLowerCase().includes(searchText.toLowerCase())  
        );
      })
    ); 
  }, [searchText, sections]);

  //Category Scrolling
  const scroll = (scrollOffset) => {
    scrollRef.current.scrollLeft += scrollOffset;
  };
  
  const scrollCheck = () => {

    setscrollX(scrollRef.current.scrollLeft);

    if (
      Math.floor(scrollRef.current.scrollWidth - scrollRef.current.scrollLeft) <=
      scrollRef.current.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
  };

  const handleResize = () => {

    if (
      scrollRef.current &&
      scrollRef?.current?.scrollWidth === scrollRef?.current?.offsetWidth      
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
    return () => {};
  };

  return (
    <Container className="main-container" fluid>
      {sectionCreated && <AlertComponent type="success" text="Section Created!" setShow={setSectionCreated}/>}
      {sectionUpdated && <AlertComponent type="primary" text="Section Updated!" setShow={setSectionUpdated}/>}
      {sectionError !== false && <AlertComponent type="danger" text={sectionError} setShow={setSectionError}/>}

      <Row >
          <Col xs={6}>
              <h2 className="page-header">Sections</h2>
          </Col>
          <Col xs={6}>          
                <Button className="primary-button border-button" style={{float: "right"}} onClick={() => {setOpenNewModal(true); setSectionID("")}} >
                  <FontAwesomeIcon icon={faPlusSquare}  size='1x' className='all-font-icons' />  New
                </Button>
          </Col>
      </Row>

      <ColoredLine color="#DEDEDE" />

      <Row className="row-level-2" >
        <h5 className="filter-headers">Category</h5> 
      </Row>
      <Row className="categories-row">
          <Container fluid className="categories-container"  ref={scrollRef} onScroll={scrollCheck}>
            <CategoryButtons setChosenCategory={setChosenCategory} chosenCategory={chosenCategory} categories={categories} /> 
          </Container>
      </Row>
      {(scrollX !== 0 || !scrolEnd) &&
        <Row>
          <Col xs={12} style={{textAlign: "center"}}>
              <Button variant="light" className="left-scroll-button" onClick={() => scroll(-50)} disabled={scrollX === 0}>
                  <FontAwesomeIcon icon={faAngleLeft}  size='1x' className='all-font-icons left-scroll-icon'  />
              </Button>
            
            <Button variant="light" className="right-scroll-button" onClick={() => scroll(+50)} disabled={scrolEnd}>
              <FontAwesomeIcon icon={faAngleRight}  size='1x' className='all-font-icons left-scroll-icon' />
            </Button>

          </Col>
        </Row>
      }

      <Row style={{marginTop: (scrollX === 0 && scrolEnd) && "10px"}}>
          <Col xs={9} sm={7} md={6}>
            <h5 className="filter-headers">Search</h5>
            <Form.Control
              onChange={(e) => setSearchText(e.target.value)}
              className="mb-3"
              type="text"
              placeholder="Search name, description or tags..."
            />
          </Col>

      </Row>

      <SectionsTable 
        sections={sectionsVisible} 
        departmentPermission={departmentPermission} 
        setSectionID={setSectionID} 
        setOpenNewModal={setOpenNewModal} 
        chosenDepartment={chosenDepartment}
      />

      {openNewModal && (
        <SectionModel
          openNewModal={openNewModal}
          setOpenNewModal={setOpenNewModal}
          setSectionCreated={setSectionCreated}
          setSectionUpdated={setSectionUpdated}
          setSectionError={setSectionError}
          getSections={getSections}
          setSections={setSections}
          sectionID={sectionID}
          sections={sections}
          chosenDepartment={chosenDepartment}
          categories={categories}
          chosenCategory={chosenCategory}
          tags={tags}
        />
      )}

     
    </Container>
  );
};

export default Sections;

